/* rs-pdp-meta-sync.js - keeps the PDP "SKU: #XXX" line on the selected variant (why, and the two states handled:
   header comment of snippets/rs-pdp-meta-sync.liquid, which loads this file). launch readiness pass 2, 2026-09-24: moved out of
   the inline <script>; loaded with `defer` - it already waits for DOMContentLoaded, so timing is unchanged. */
(function () {
  if (window.__rsPdpMetaSyncInit) return;
  window.__rsPdpMetaSyncInit = true;

  function init() {
    var picker = document.querySelector('block-variant-picker');
    var meta = document.querySelector('.pdp-meta');
    if (!picker || !meta) return;

    // The block emits "SKU: <strong>#XXX</strong>" as one .pdp-meta__item,
    // alongside an unrelated "Min. seed count" item. Match on the label so a
    // future reorder of those items cannot make this rewrite the wrong one.
    // 2026-11-03: the item is "<span hidden>SKU </span><strong>#XXX</strong> · Min. N seeds" (no visible label,
    // the seed count rides along) and carries data-rs-sku; the label match stays as the fallback.
    var skuItems = document.querySelectorAll('[data-rs-sku]');   // the meta row item (every width since 2026-11-03)
    var skuItem = skuItems[0] || null;
    var items = meta.querySelectorAll('.pdp-meta__item');
    for (var i = 0; !skuItem && i < items.length; i++) {
      if (/^\s*SKU\s*:?/i.test(items[i].textContent)) { skuItem = items[i]; break; }
    }
    if (!skuItem) return;

    var strong = skuItem.querySelector('strong');
    if (!strong) return;

    function show(sku) {
      for (var k = 0; k < skuItems.length; k++) {
        var st = skuItems[k].querySelector('strong');
        if (sku) { if (st) st.textContent = '#' + sku; skuItems[k].hidden = false; }
        else { skuItems[k].hidden = true; }
      }
    }

    // Does the SKU actually differ between variants? On the gift certificate
    // all seven denominations share one SKU (GIFT-CERTIFICATE), so hiding it
    // until an amount is picked would blank a line that was never going to
    // change and then pop it back — flicker that reads as a bug. Only the
    // shared-SKU case is exempt; a real per-variant SKU still hides.
    var skuVaries = true;
    try {
      var data = JSON.parse(picker.querySelector('[type="application/json"]').textContent);
      var seen = {};
      for (var v = 0; v < data.length; v++) seen[data[v].sku || ''] = 1;
      skuVaries = Object.keys(seen).length > 1;
    } catch (err) {
      /* unreadable variant data — keep the safe behaviour and hide */
    }

    // Opening state. When a choice is required nothing is selected yet, so the
    // server-rendered SKU belongs to a variant the shopper has not picked.
    if (skuVaries && document.querySelector('block-buy-buttons[data-require-selection]')) {
      show(null);
    }

    // The picker namespaces its event by section and product.
    var name = 'variant:change:' + picker.dataset.sectionId + ':' + picker.dataset.productId;
    document.addEventListener(name, function (e) {
      var detail = e.detail || {};
      // `loading: true` fires first, before the section fetch resolves, and
      // already carries the matched variant -- update on it so the SKU never
      // lags behind the price.
      if (!skuVaries) return;
      show(detail.variant && detail.variant.sku ? detail.variant.sku : null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
